import {useEffect} from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useSearchParams, Link} from 'react-router'

import AlertCustom from '../../ui/alert/AlertCustom'
import {CodeflField} from '../../ui/form/login/LoginFields'
import {PasswordField} from '../../ui/form/login/PasswordField.tsx'
import Loader from '../../ui/loader/Loader'
import Field from '../../ui/form/Field';
import {useLogin} from '../../../hooks/useLogin.ts'
import EasiwareForm from '../../ui/form/easiware/EasiwareForm'
import {ImpersonateProps} from './Login.tsx'

interface LoginFormInterface extends ImpersonateProps {
  location?: {
    state: {
      referer: string,
    },
  },
}

const LoginForm = ({location, impersonate}: LoginFormInterface) => {
    const {
        state,
        dispatch,
        initCredentials,
        handleChange,
        handleSubmit,
        handleSubscriptionModal,
    } = useLogin(location, impersonate)
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const agent = searchParams.get('agent')
    const codefl = searchParams.get('codefl')

    if (impersonate && agent && codefl) {
      initCredentials({username: agent, codefl})
    }
  }, [impersonate])

    return (
        <>
            <div className="px-3 py-4">
                <Row>
                    <Col
                        md={{span: 10, offset: 1}}
                        xl={{span: 8, offset: 2}}
                        className="col-hd-6 offset-hd-3">
                        <h1>Me connecter</h1>

                        <AlertCustom
                            heading={false}
                            variant="danger"
                            bodyContent={state.errorMessage}
                            transition={!!state.isError}
                            dismissible={false}
                            onClose={() =>
                                dispatch({
                                    type: 'HANDLE_FOCUS',
                                })
                            }
                        />

                        <Form onSubmit={handleSubmit}>
                            <CodeflField
                                classNames="mb-3"
                                value={state.credentials.codefl}
                                onChange={handleChange}
                                onFocus={() => dispatch({type: 'HANDLE_FOCUS'})}
                                error={state.errorField.codefl}
                            />

                            {impersonate && (
                                <Field
                                    label={'Email agent'}
                                    placeholder={'Email'}
                                    classNames={'mb-3'}
                                    labelRequired={true}
                                    name={'username'}
                                    onChange={handleChange}
                                    value={state.credentials.username}
                                    error={state.errorField.username}
                                />
                            )}

                            <PasswordField
                                label={'Mot de passe'}
                                placeholder={'Mot de passe'}
                                isRequired={true}
                                name={'password'}
                                value={state.credentials.password}
                                onChange={handleChange}
                                onFocus={() => dispatch({type: 'HANDLE_FOCUS'})}
                                error={state.errorField.password}
                            />

                            <div className="d-flex flex-columns align-items-center justify-content-between mt-3">
                                <div>
                                    <Button
                                        type="submit"
                                        className="btn-primary mr-3"
                                        disabled={state.isLoading}>
                                        {state.isLoading ? (
                                            <Loader
                                                variant="white"
                                                size="sm"
                                                classname="my-1 mx-3"
                                            /> // Indique le loading du dispatch 'FETCH_INIT'
                                        ) : (
                                            'Valider'
                                        )}
                                    </Button>
                                </div>
                                <div>
                                    <div>
                                        <Link
                                            to={{pathname: '/forgot-password'}}
                                            className={
                                                'btn-link text-grey-darker'
                                            }>
                                            J'ai oublié mon mot de passe
                                        </Link>
                                    </div>
                                    <div>
                                        <a
                                            role="button"
                                            className="btn-link text-grey-darker"
                                            onClick={() => {
                                                handleSubscriptionModal(true)
                                            }}>
                                            Adhérer au service par email
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </div>

            <EasiwareForm
                state={state}
                handleModalShow={handleSubscriptionModal}
                formId={3}
                headerTitle={"Formulaire d'adhésion"}
            />
        </>
    )
}

export default LoginForm
